module.exports = __webpack_public_path__ + "img/585-42dfb3.png";